<template>
  <label class="flex items-center cursor-pointer m-1">
    <!-- toggle -->
    <div class="relative">
      <!-- input -->
      <input type="checkbox" class="sr-only" :checked="modelValue" @change="onChange" />
      <!-- line -->
      <div
        class="block w-9 h-[19px] rounded-full transition-colors"
        :class="{ 'bg-blue-500': modelValue, 'bg-gray-400': !modelValue }"
      ></div>
      <!-- dot -->
      <div
        class="absolute left-px top-px bg-white w-[17px] h-[17px] rounded-full transition-transform"
        :class="{ 'transform translate-x-full': modelValue }"
      ></div>
    </div>
    <!-- label -->
    <div v-if="label || $slots.default" class="ml-3 text-gray-700 font-medium">
      <slot>{{ label }}</slot>
    </div>
  </label>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  label: {
    type: String as PropType<string>,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue', 'change']);
const onChange = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).checked);
  emit('change', (e.target as HTMLInputElement).checked);
};
</script>
